import React, { useEffect, useState } from "react";
import { getBalanceLeaves } from "../../api/leavesApi"; 
import "../../css/CustomTable.css";

export default function BalanceLeaves() {
  const [employees, setEmployees] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    fetchData();
  }, [year]);

  const fetchData = async () => {
    try {
      const data = await getBalanceLeaves(year);
      console.log("Data inside component:", data);

      const grouped = {};
      data.forEach(emp => {
        const key = emp.employeeCode;
        if (!grouped[key]) {
          grouped[key] = {
            employeeCode: emp.employeeCode,
            fullName: emp.fullName,
            CL: { prev: 0, current: 0, balance: 0 },
            SL: { prev: 0, current: 0, balance: 0 },
            PL: { prev: 0, current: 0, balance: 0 }
          };
        }
        grouped[key][emp.leaveCode] = {
          prev: emp.prevYear,
          current: emp.currentYear,
          balance: emp.balance
        };
      });

      setEmployees(Object.values(grouped));
    } catch (error) {
      console.error("Error fetching employees without leave", error);
      setEmployees([]);
    }
  };

  return (
    <div className="container-fluid p-1">
      <h4 className="allowance-heading">Employees Balance Leaves</h4>

      {/* Year Input */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <label htmlFor="yearInput" className="fw-bold mb-0">
            Enter Year:
          </label>
          <input
            id="yearInput"
            type="number"
            className="form-control"
            style={{ width: "150px" }}
            value={year}
            onChange={(e) => setYear(e.target.value)}
            min="2000"
            max="2100"
          />
        </div>
      </div>

      {/* Employees Table */}
      <div className="allowance-table-container mb-4">
        <table className="allowance-table">
          <thead>
            <tr>
              <th rowSpan="2">Sr</th>
              <th rowSpan="2">Employee Code</th>
              <th rowSpan="2">Employee Name</th>
              <th colSpan="3" style={{ textAlign: "center" }}>CL</th>
              <th colSpan="3" style={{ textAlign: "center" }}>SL</th>
              <th colSpan="3" style={{ textAlign: "center" }}>PL</th>
            </tr>
            <tr>
              <th>Prev</th>
              <th>Current</th>
              <th>Balance</th>
              <th>Prev</th>
              <th>Current</th>
              <th>Balance</th>
              <th>Prev</th>
              <th>Current</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map((emp, index) => (
                <tr key={emp.employeeCode}>
                  <td>{index + 1}</td>
                  <td>{emp.employeeCode}</td>
                  <td>{emp.fullName}</td>

                  <td>{emp.CL?.prev ?? 0}</td>
                  <td>{emp.CL?.current ?? 0}</td>
                  <td>{emp.CL?.balance ?? 0}</td>

                  <td>{emp.SL?.prev ?? 0}</td>
                  <td>{emp.SL?.current ?? 0}</td>
                  <td>{emp.SL?.balance ?? 0}</td>

                  <td>{emp.PL?.prev ?? 0}</td>
                  <td>{emp.PL?.current ?? 0}</td>
                  <td>{emp.PL?.balance ?? 0}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="text-center">
                  No employees found 🎉
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}







// import React, { useEffect, useState } from "react";

// import { getBalanceLeaves } from "../../api/leavesApi"; 
// import "../../css/CustomTable.css";

// export default function BalanceLeaves() {
//   const [employees, setEmployees] = useState([]);
//   const [year, setYear] = useState(new Date().getFullYear());


//   useEffect(() => {
//     fetchData();
//   }, [year]);

//     const fetchData = async () => {
//         try {
//           const data = await getBalanceLeaves(year);
//           console.log("Data inside component:", data);
//           setEmployees(data || []);
//         } catch (error) {
//           console.error("Error fetching employees without leave", error);
//           setEmployees([]);
//         }
//       };

//       return (
//     <div className="container-fluid p-1">
//       {/* Heading */}
//       <h4 className="allowance-heading">Employees Balance Leaves</h4>
    

//       {/* Year Input + Buttons */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <div className="d-flex align-items-center" style={{ gap: "10px" }}>
//           <label htmlFor="yearInput" className="fw-bold mb-0">Enter Year:</label>
//           <input
//             id="yearInput"
//             type="number"
//             className="form-control"
//             style={{ width: "150px" }}
//             value={year}
//             onChange={(e) => setYear(e.target.value)}
//             min="2000"
//             max="2100"
//           />
//         </div>
//          </div>
        

//       {/* Employees Table */}
//       <div className="allowance-table-container mb-4">
//         <table className="allowance-table">
//           <thead>
//             <tr>
//               <th>Sr</th>
//               <th>Employee Code</th>
//               <th>Employee Name</th>
//               <th>Leave Code</th>
//               <th>Previous Year</th>
//               <th>Current Year</th>
//               <th>Balance Leaves</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.length > 0 ? (
//               employees.map((emp, index) => (
//                 <tr key={emp.employeeLeaveID || index}>
//                   <td>{index + 1}</td>
//                   <td>{emp.employeeCode}</td>
//                   <td>{emp.fullName}</td>
//                   <td>{emp.leaveCode}</td>
//                   <td>{emp.prevYear}</td>
//                   <td>{emp.currentYear}</td>
//                   <td>{emp.balance}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4" className="text-center">
//                   No employees found 🎉
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }




// import React, { useEffect, useState } from "react";
// import { getBalanceLeaves } from "../../api/leavesApi"; 
// import "../../css/CustomTable.css";

// export default function BalanceLeaves() {
//   const [employees, setEmployees] = useState([]);
//   const [year, setYear] = useState(new Date().getFullYear());

//   useEffect(() => {
//     fetchData();
//   }, [year]);

//   const fetchData = async () => {
//     try {
//       const data = await getBalanceLeaves(year);
//       console.log("Data inside component:", data);

//       const grouped = {};
//       data.forEach(emp => {
//         const key = emp.employeeCode;
//         if (!grouped[key]) {
//           grouped[key] = {
//             employeeCode: emp.employeeCode,
//             fullName: emp.fullName,
//             CL: { prev: 0, current: 0, balance: 0 },
//             SL: { prev: 0, current: 0, balance: 0 },
//             PL: { prev: 0, current: 0, balance: 0 }
//           };
//         }
//         // overwrite only the leave code returned
//         grouped[key][emp.leaveCode] = {
//           prev: emp.prevYear,
//           current: emp.currentYear,
//           balance: emp.balance
//         };
//       });

//       setEmployees(Object.values(grouped));
//     } catch (error) {
//       console.error("Error fetching employees without leave", error);
//       setEmployees([]);
//     }
//   };

//   return (
//     <div className="container-fluid p-1">
//       <h4 className="allowance-heading">Employees Balance Leaves</h4>

//       {/* Year Input */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <div className="d-flex align-items-center" style={{ gap: "10px" }}>
//           <label htmlFor="yearInput" className="fw-bold mb-0">
//             Enter Year:
//           </label>
//           <input
//             id="yearInput"
//             type="number"
//             className="form-control"
//             style={{ width: "150px" }}
//             value={year}
//             onChange={(e) => setYear(e.target.value)}
//             min="2000"
//             max="2100"
//           />
//         </div>
//       </div>

//       {/* Employees Table */}
//       <div className="allowance-table-container mb-4">
//         <table className="allowance-table">
//           <thead>
//             <tr>
//               <th>Sr</th>
//               <th>Employee Code</th>
//               <th>Employee Name</th>
//               <th>CL Balance</th>
//               <th>SL Balance</th>
//               <th>PL Balance</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.length > 0 ? (
//               employees.map((emp, index) => (
//                 <tr key={emp.employeeCode}>
//                   <td>{index + 1}</td>
//                   <td>{emp.employeeCode}</td>
//                   <td>{emp.fullName}</td>
//                   <td>{emp.CL?.balance ?? 0}</td>
//                   <td>{emp.SL?.balance ?? 0}</td>
//                   <td>{emp.PL?.balance ?? 0}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="6" className="text-center">
//                   No employees found 🎉
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }
